'use strict';

/** @type {import('.')} */
module.exports = Object;



//////////////////
// WEBPACK FOOTER
// ./~/es-object-atoms/index.js
// module id = 1003
// module chunks = 41